<template>
  <span>
    <button type="button" class="btn btn-warning btn-xs mr-1" @click="toggle">
      <i class="fas fa-undo"></i>&nbsp;Restore
    </button>

    <b-modal
      ref="modal-container"
      v-model="modalShow"
      size="lg"
      title="Confirm restore?"
      hide-footer
      @show="resetModal"
      @hidden="resetModal"
    >
      <span>
        {{ message }}: <b>{{ object }}</b>.
      </span>
      <b-button class="mt-2 float-right" variant="warning" @click="handleSubmit">Restore</b-button>
    </b-modal>
  </span>
</template>

<script>
export default {
  props: ['object', 'message', 'url'],
  data() {
    return {
      modalShow: false,
    };
  },
  methods: {
    resetModal() {},
    hideModal() {
      this.$refs['modal-container'].hide();
    },
    toggle() {
      this.modalShow = !this.modalShow;
    },
    handleSubmit() {
      this.$http({
        url: this.url,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(() => {
          setTimeout(() => {
            this.$emit('finish');
          }, 500);

          this.hideModal();
          this.$toastr.i('Success');
        })
        .catch((err) => {
          const message = err?.response?.data?.message ?? 'Restore failed';
          this.$toastr.e(JSON.stringify(message));
          throw err;
        });
    },
  },
};
</script>
